import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        containerImg: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexGrow: 1,
            paddingTop: theme.spacing(3),
        },
        durationHours: {
            '&&': {
                width: '50%',
                display: 'inline-block',
                boxSizing: 'border-box',
                paddingRight: theme.spacing(1.5),
            },
        },
        durationMinutes: {
            '&&': {
                width: '50%',
                display: 'inline-block',
                boxSizing: 'border-box',
                paddingLeft: theme.spacing(1.5),
            },
        },
    }
})

export default useStyles
